import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { formatDateShort } from '../../helpers/utils'

interface ChartData {
  _id: string
  clicks: number
}

interface ChartProps {
  data: ChartData[]
  type: string
  dateRange: string
}

const ByTimeChart: React.FC<ChartProps> = ({ data, type, dateRange }) => {
  const { t } = useTranslation()

  const time = data.map((item) => formatDateShort(item._id))
  const quantity = data.map((item) => item.clicks)

  const chartOptions: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
    },
    xaxis: {
      categories: time,
      labels: {
        show: true,
        style: {
          fontWeight: 900,
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          fontWeight: 900,
        },
      },
    },
    colors: ['#F47524'],
    fill: {
      opacity: 1,
      type: 'solid',
    },
    tooltip: {
      enabled: true,
    },
    dataLabels: {
      style: {
        colors: ['#FFFFFF'],
        fontWeight: 'bold',
        fontSize: '14px',
      },
      textAnchor: 'middle',
    },
  }

  const series = [
    {
      data: quantity,
      name: '',
    },
  ]

  return (
    <>
      <div className='container-flex-block justify-content-between'>
        <span
          className='title py-4 text-left bolder'
          dangerouslySetInnerHTML={{
            __html: `${t(type === 'url' ? 'CLICKS_BY_TIME' : 'SCAN_BY_TIME')}`,
          }}
        />
        <span className='title py-4 text-initial bolder'>{dateRange}</span>
      </div>
      <div>
        <ReactApexChart
          options={chartOptions}
          series={series}
          type='bar'
          height={300}
        />
      </div>
    </>
  )
}

export default ByTimeChart
